// extracted by mini-css-extract-plugin
module.exports = {"h4":"footer-module--h4--Or7Ru","bg":"footer-module--bg--3GhEw","svg":"footer-module--svg--1qP4P"};